import React from "react";

import DefaultModal from "@/components/ui/modals/DefaultModal";

import AddModal from "../shared/AddModal";

/**
 * Modal component for adding a new view
 * @param {Object} props - Component props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {() => void} props.onClose - Function to close the modal
 * @param {string} props.title - Title of the modal
 * @param {boolean} props.isView - Whether this is a view or a list
 * @see src/components/ui/modals/DefaultModal.tsx
 * @see src/components/companies/companiesList/newCompaniesList/viewListTools/shared/AddModal.tsx
 */
const AddViewModal = ({ 
  isOpen, 
  onClose, 
  title, 
  isView 
}: { 
  isOpen: boolean; 
  onClose: () => void; 
  title: string; 
  isView: boolean;
}) => {
  return (
    <DefaultModal
      {...{
        isOpen,
        onClose,
        isCloseBtn: false,
        content_style: {
          p: "12px",
        },
        modalStyle: {
          borderRadius: "4px",
        },
      }}
    >
      <AddModal onClose={onClose} title={title} isView={isView} />
    </DefaultModal>
  );
};

export default AddViewModal;
